import { useEffect, useState } from 'react';
import { getDurationFromDates } from 'utils/timeUtils';
/**
 * Hook for getting duration to time now in selected format with desired interval
 * @param  {Date} startDate Date of start time
 * @param  {number} interval Interval for how often time updates (default 1000ms).
 * @param  {string[]} format Format array defining what is shown (days, hours, minutes, seconds).
 * @return {string} Returns and updates duration in selected units at the given interval.
 */
const useDurationFromDate = (
  startDate: Date | null,
  interval: number = 1000,
  format: string[] = ['days', 'hours', 'minutes', 'seconds']
): string => {
  const validDate = startDate || new Date();
  const [duration, setDuration] = useState(() =>
    getDurationFromDates(validDate, new Date(), format)
  );

  useEffect(() => {
    const updateDuration = () => {
      setDuration(getDurationFromDates(validDate, new Date(), format));
    };
    updateDuration(); // Ensure it updates immediately on mount
    const durationInterval = setInterval(updateDuration, interval);
    return () => clearInterval(durationInterval);
  }, [startDate, interval, format]);
  if (duration === '' && format && !format.includes('seconds')) {
    return '1 min';
  }
  return duration;
};

export default useDurationFromDate;
